import { useAuth0 } from "@auth0/auth0-react";
import { LoadingPage } from "../components/LoadingPage.tsx";
import { Navigate, useLocation } from "react-router-dom";

export const AuthenticationGuard = ({ component: Component }) => {
  const { isLoading, isAuthenticated } = useAuth0();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="page-layout">
        <LoadingPage />
      </div>
    );
  }

  if (!isAuthenticated) {
    const returnTo = location.pathname + location.search;
    return <Navigate to={`/login?returnTo=${encodeURIComponent(returnTo)}`} replace />;
  }

  return <Component />;
};
